export enum BRAND {
  BETTERMAKER = "Bettermaker",
  CHANDLER_LIMITED = "Chandler Limited",
  CRANBORNE = "Cranborne",
  DE_FI = "DE-FI",
  DIYRE = "DIYRE",
  EMPIRICAL_LABS = "Empirical Labs",
  GRACE_DESIGN = "Grace Design",
  HAZELRIGG = "Hazelrigg",
  HEISERMAN = "Heiserman Audio",
  LINDELL_AUDIO = "Lindell Audio",
  MOJAVE_AUDIO = "Mojave Audio",
  MOTHER = "Mother",
  NEVE = "Neve",
  POPE_AUDIO = "Pope Audio",
  PRISM_SOUND = "Prism Sound",
  PURPLE_AUDIO = "Purple Audio",
  QUAGLIARDI = "Quagliardi Audio",
  RADIAL = "Radial Engineering",
  SERPENT = "Serpent Audio",
  SHADOWHILLS = "Shadow Hills Industries",
  SOUND_SKULPTOR = "Sound Skulptor",
  SSL = "SSL",
  TEGELER_AUDIO = "Tegeler Audio",
  WARM_AUDIO = "Warm Audio",
  WESAUDIO = "WesAudio",
}
